<template>
  <div v-if="userHasAccess" id='results' class="">
    <!--Sticy Top Nav for Show book Page -->
    <div class="sticky top-0 z-40">
      <div v-if="testMode" class="flex space-x-2 items-center justify-center py-4 bg-blue-600 text-center sticky top-0">
        <p class=" text-lg text-white mb-0.5">You are currently in test mode for the results tool.</p>
        <button class="text-sm text-white py-1.5 px-2 border rounded-md hover:bg-white hover:text-blue-600 hover:font-medium" @click="testModeChange">Leave Test Mode</button>
      </div>
      <div v-if="resultsLoaded" class="bg-white py-1 sm:py-2 shadow">
        <div class="flex flex-col md:flex-row justify-between">
          <nav class="flex px-1 sm:px-2" aria-label="Breadcrumb">
            <ol role="list" class="flex items-center space-x-1 sm:space-x-2">
              <li>
                <div>
                  <button class="text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800">
                    Results
                  </button>
                </div>
              </li>
              <li v-if="show_book">
                <div class="flex items-center">
                  <svg class="h-4 sm:h-5 w-4 sm:w-5 flex-shrink-0 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                  </svg>
                  <button @click="navClicked('show')" class="ml-1 sm:ml-3 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800">{{show_book.name}}</button>
                </div>
              </li>

              <li v-if="selectedDivision">
                <div class="flex items-center">
                  <svg class="h-4 sm:h-5 w-4 sm:w-5 flex-shrink-0 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                  </svg>
                  <button @click="navClicked('division')" class="ml-1 sm:ml-3 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800" aria-current="page">{{selectedDivision.name}}</button>
                </div>
              </li>
            </ol>
          </nav>
          <div class="flex flex-wrap justify-end items-center pt-1 md:pt-0 mt-1 md:mt-0 border-t md:border-none space-x-2 mr-2">
            <premier-exhibitor/>
            <button v-if="!resultsSaving" class="text-base font-semibold mr-3 inline-flex items-center rounded-md border border-transparent bg-green-500 px-3 py-1.5 text-base font-medium leading-4 text-white shadow-sm hover:text-green-100 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2" @click="updateShowBook">Save Results</button>
            <div v-else><vue-simple-spinner size="medium" message="Saving Results" line-fg-color="orange"/></div>
            <div v-if="!testMode" class="md:flex md:items-center">
              <label class="block text-gray-800 font-lg font-bold flex items-center">
                <input v-model="results_published" class="mr-1 leading-tight" type="checkbox" @change="resultsPublishedUpdate">
                <span class="text-sm">
                  Publish Results
                </span>
              </label>
            </div>
            <dropdown-button ref="dropdownButton">
              <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
              </span>
              <div slot="dropdown" class="w-64 bg-white border shadow rounded-md overflow-hidden text-left divide-y divide-gray-200 text-sm">

                <div class="py-1" role="none">
                  <DownloadDataUI :options="downloadShowOptions" :retrieveData="getBulkShowBooks" :headers="detailed_headers" :fileName="`${adminData.event.name.replaceAll(' ', '_')}_results`"/>
                  <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" @click="testModeChange">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" data-slot="icon" class="mr-3 w-5 h-5">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                    <template v-if="testMode">
                      Exit Test Mode
                    </template>
                    <template v-else>
                      Enter Test Mode
                    </template>
                  </button>
                </div>
              </div>
            </dropdown-button>
            <dropdown-button ref="extras_dropdownButton" v-if="adminData.pricing_plan_id === '02008de0-7da0-11ed-ba14-1248ddbb6de9'">
              <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                </svg>
              </span>
              <div slot="dropdown" class="w-64 bg-white border shadow rounded-md overflow-hidden text-center divide-y divide-gray-200 text-sm">
                <div class="p-3 divide-y" role="none">
                  <div class="md:flex md:items-center py-2">
                    <label class="block text-gray-800 font-lg font-bold flex items-center">
                      <input v-model="show_settings.record_scores" class="mr-1 leading-tight" type="checkbox" @change="showSettingsUpdate('record_scores')">
                      <span class="text-sm">
                        Record Scores
                      </span>
                    </label>
                  </div>
                  <div class="md:flex md:items-center py-2">
                    <label class="block text-gray-800 font-lg font-bold flex items-center">
                      <input v-model="show_settings.record_ribbon_placings" class="mr-1 leading-tight" type="checkbox" @change="showSettingsUpdate('record_ribbon_placings')">
                      <span class="text-sm">
                        Record Ribbon Placings
                      </span>
                    </label>
                  </div>
                  <!--<button class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" @click="testModeChange">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" data-slot="icon" class="mr-3 w-5 h-5">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                    <template v-if="testMode">
                      Exit Test Mode
                    </template>
                    <template v-else>
                      Enter Test Mode
                    </template>
                  </button>-->
                </div>
              </div>
            </dropdown-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!show_book">
      <div class="border-b border-gray-200 p-3 mx-2 flex justify-between">
        <h3 class="text-lg font-medium leading-6 text-gray-900">Results</h3>
        <DownloadDataUI type="button" :options="downloadShowOptions" :retrieveData="getBulkShowBooks" :headers="detailed_headers" :fileName="`${adminData.event.name.replaceAll(' ', '_')}_results`"/>
      </div>
      <div class="px-2 md:px-0 mx-auto max-w-lg mt-8">
        <div class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-12 w-12 text-gray-500">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
          </svg>
          <h2 class="mt-2 text-lg font-medium text-gray-900">Select a results book</h2>
          <p class="mt-1 text-sm text-gray-600">Choose the show you would like to view results for.</p>
        </div>
        <div class="mt-6">
          <multiselect @input="getShowBook" v-model="show_book" :options="adminData.show_books" :multiple="false" :close-on-select="true" :clear-on-select="true" :allowEmpty="false" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true">
            <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
              {{option.name}}
            </div>
          </multiselect>
        </div>
      </div>
    </div>

    <div v-else-if="resultsLoading" class="pt-12">
      <vue-simple-spinner size="huge" message="Loading Results" line-fg-color="orange"/>
    </div>

    <div v-else-if="resultsLoaded" ref="top">
      <div class="bg-gray-200 px-2 sm:px-4 py-2 sm:py-4 border-b flex flex-col space-y-3">
        <div class="flex-col md:flex-row flex justify-between md:space-x-3 px-2 space-y-2 md:space-y-0">
          <div class="w-full md:w-1/2 flex-shrink-0">
            <label for="show" class="block text-lg font-medium text-gray-700 mb-1">Show Book ({{totalEntries}} Entries)</label>
            <multiselect ref="show_dropdown" @input="getShowBook" v-model="show_book" :options="adminData.show_books" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true"></multiselect>
          </div>
          <div class="w-full">
            <label for="ring" class="block text-lg font-medium text-gray-700 mb-1">Division</label>
            <multiselect ref="division_dropdown" v-model="selectedDivision" :options="division_list" :multiple="false" :close-on-select="true" :clear-on-select="false" :allowEmpty="false" :preserve-search="true" placeholder="Select a division" label="name" :preselect-first="false" :custom-label="(option) => {return `${option.name} ${option.is_champion ? 'Champions' : `(${option.count})`}`}" :hideSelected="false">
              <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
                {{option.name}} ({{option.count}})
              </div>
            </multiselect>
          </div>
        </div>
      </div>
      <div id="showbook-section" v-if="show_book" class="px-2 md:px-4  flex flex-col-reverse md:flex-row justify-between" :class="{'border-4': testMode, 'border-blue-600': testMode, 'mr-1': testMode}">
        <div v-if="show_book.show_book" class="flex flex-col w-full max-w-6xl py-4">
          <div v-for="(c, i) in classList.filter(c => c.division === (selectedDivision ? selectedDivision.name : c.division))" :key="i">
            <div class="py-1.5" :class="{'md:pl-6': c.entryType === 'Champion'}" v-if="c.full_class_name">
              <div id="class-header" class="bg-gray-200_ rounded-t-md">
                <div class="flex flex-col md:flex-row  justify-between md:items-center" >
                  <div class="flex justify-start items-center">
                    <div v-if="c.entryType !== 'Champion'" class="pt-2 pb-1 text-base md:text-xl font-medium" >
                      <!--<div v-html="c.new_class_name"></div>-->
                      <div v-html="c.full_class_name"></div>
                    </div>
                    <div v-else class="py-0.5 text-base md:text-xl font-bold" >
                      <!--<div v-html="c.new_class_name"></div>-->
                      <div v-html="c.full_class_name"></div>
                    </div>
                  </div>
                  <div class="text-base"  v-if="c.entryType ==='standard' && c.entries">({{c.entries.length}} {{ c.entries.length === 1 ? 'Entry' : 'Entries' }})</div>
                </div>
              </div>
              <div v-if="c.entryType === 'standard'">
                <div v-for="(e, j) in c.entries" :key="j" class="odd:bg-gray-100 border-t">
                  <div class="flex justify-between pl-2 md:pl-6 pr-2 py-1.5  items-center space-x-4">
                    <div class="text-center flex items-start justify-start space-x-1 text-base font-medium mr-4">
                      <template v-if="adminData.event.status !== 'ARCHIVED'">
                        <div>
                          <input v-model="e.place" @change="updateEntryPlacing(e)" class="border border-gray-700 w-8 p-0.5 h-8 rounded text-center">
                          <p class='text-xs' v-if="show_settings.record_scores || show_settings.record_ribbon_placings">Place</p>
                        </div>
                        <div v-if="show_settings.record_scores">
                          <input v-model="e.score" @change="updateEntryScore(e)" class="border border-gray-700 w-10 font-medium h-8 p-0.5 rounded text-center text-sm">
                          <p class='text-xs'>Score</p>
                        </div>
                        <div v-if="show_settings.record_ribbon_placings">
                          <!--<input v-model="e.score" @change="updateEntryScore(e)" class="border border-gray-700 w-10 font-medium p-1 rounded text-center text-xs">-->
                          <v-select
                            class="bg-gray-200 rounded w-24 text-sm"
                            v-model="e.ribbon"
                            :options="['Blue', 'Red', 'White', 'Purple', 'Green']"
                            :clearable="false"
                            @input="updateEntryRibbon(e)"
                          >
                          </v-select>
                          <p class='text-xs'>Ribbon</p>
                        </div>
                      </template>
                      <template v-else>
                        <input v-model="e.place" disabled class="border bg-gray-400 text-black border-gray-600 w-10 p-1 rounded mr-1">
                        <div v-if="show_settings.record_scores">
                          <input v-model="e.score" disabled class="border bg-gray-400 text-black border-gray-600 w-10 p-1 rounded mr-1">
                          <p class='text-xs'>Score</p>
                        </div>
                      </template>
                    </div>
                    <div class="flex flex-1 flex-col sm:flex-row sm:justify-between sm:items-center md:space-x-4">
                      <div class='flex items-center text-base'>
                        <div v-html="calculateExhibitor(e)"></div>
                      </div>
                      <div class="flex flex-col flex-1">
                        <div>
                          <div class="flex justify-between">
                            <div>
                              <div class="sm:text-base font-bold" v-if="e.entry_details.name">{{String(e.entry_details.name).toUpperCase()}}</div>
                              <div class="sm:text-base font-bold" v-else-if="e.entry_details.animal_id">{{`${String(e.entry_details.animal_id).toUpperCase()}`}}</div>
                              <div class="flex space-x-2 text-sm">
                                <div class="sm:text-sm font-medium" v-if="e.entry_details.left_tattoo">{{`${String(e.entry_details.left_tattoo).toUpperCase()}`}}</div>
                                <div class="sm:text-sm font-medium" v-if="e.entry_details.right_tattoo">{{`${String(e.entry_details.right_tattoo).toUpperCase()}`}}</div>
                                <div class="sm:text-sm font-medium" v-if="e.entry_details.microchip_id">{{`${String(e.entry_details.microchip_id).toUpperCase()}`}}</div>
                              </div>
                            </div>
                            <div v-if="event_show_type.class_calc.calculate_by === 'weight' || c.break_type==='weight'" class="text-lg ">
                              {{e.entry_details.weight}}<span v-if="weightLabel.toLowerCase().includes('weight')">lbs</span>
                              <span v-else> {{ weightLabel }}</span>
                            </div>
                            <div v-else-if="e.entry_details.date_of_birth" class="text-base ">{{formatDate(e.entry_details.date_of_birth)}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center flex flex-col md:flex-row md:items-center justify-end space-y-1 md:space-y-0 md:space-x-1">
                      <button class="inline-flex items-center rounded border border-red-400 bg-red-40_0 px-2 py-1 text-xs font-medium text-red-400 shadow-sm hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" @click="gateScratchEntry(e)">Scratch</button>
                      <button  class="inline-flex justify-center items-center rounded border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" @click="dqEntry(e)">DQ</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="pr-2">
                <div class="text-center flex items-center justify-center flex-wrap">
                  <!--<multiselect v-if="adminData.event.status !== 'ARCHIVED'" @input="setChampionResult(c)" class="" v-model="c.winner" :options="potentialChampionEntries.filter(e => { return (((e.division ? (e.division === c.division) : true) || c.division === 'Overall'))})" placeholder="Select an entry" label="name" :custom-label="(option) => {return `${option.exhibitor} ~ ${option.name ? option.name : option.animal_id ? option.animal_id :''}${option.division ? ` ~ ${option.division}` : ''}`}"  track-by="name"></multiselect>-->
                  <template v-if="(c.settings ? c.settings.champion_type === 'WRITE' : false)">
                    <input class="new-form-input w-full" type="text" v-model="c.winner">
                  </template>
                  <template v-else>
                    <multiselect v-if="adminData.event.status !== 'ARCHIVED'" @input="setChampionResult(c)"  v-model="c.winner" :options="getChampionList2(c)" placeholder="Select an entry" label="name" :custom-label="(option) => {return `${option.exhibitor_number ? option.exhibitor_number : ''} ${option.exhibitor} ~ ${option.name ? option.name : option.animal_id ? option.animal_id :''}${option.division ? ` ~ ${option.division}` : ''}`}"  track-by="name"></multiselect>
                    <p class="py-2 text-xl font-medium" v-else-if="c.winner"> {{`${c.winner.exhibitor} ~ ${c.winner.name ? c.winner.name : c.winner.animal_id ? c.winner.animal_id :''}${c.winner.division ? ` ~ ${c.winner.division}` : ''}`}} </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-8 max-w-md mx-auto py-4">
          <p class="text-2xl ">No Show Book Found</p>
          <p>A show book must be generated before results can be recorded. Show books can be generated under the Show Books Tab of the admin dashboard.</p>
        </div>
        <showman-live-controller v-if="adminData.event.event_id === 'ab87ca5a-a661-11ee-8bf2-1248ddbb6de9'" class="hidden md:block w-full md:w-96" ref="liveController"/>
      </div>
    </div>
  </div>
  <div v-else>
    <NoAccess :section="'Results'" :admin_email="adminData.show_admin.email"/>
  </div>
</template>

<script>
// import ExportData from '@/components/admin/ExportData.vue'
import Vue from 'vue'
import PremierExhibitor from '@/components/admin/PremierExhibitor.vue'
import NoAccess from '@/views/admin/NoAccess.vue'
import DownloadDataUI from '@/components/DownloadDataUI.vue'
import ShowmanLiveController from '@/components/admin/ShowmanLiveController.vue'
// const CLASS_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'II', 'JJ', 'KK', 'LL', 'MM', 'NN', 'OO', 'PP', 'QQ', 'RR', 'SS', 'TT', 'UU', 'VV', 'WW', 'XX', 'YY', 'ZZ']

export default {
  components: {
    PremierExhibitor,
    NoAccess,
    DownloadDataUI,
    ShowmanLiveController
  },
  data () {
    return {
      show_book: null,
      show_settings: {},
      resultsLoading: false,
      resultsSaving: false,
      results_published: false,
      selectedDivision: null,
      testMode: false,
      allResults: [],
      loadingAllResults: false
    }
  },
  methods: {
    calculateNumberToPrint (e) {
      if (this.event_show_type.class_calc.use_exhibitor_numbers) {
        return `${e.exhibitor.exhibitor_number} - `
      } else if (e.entry_number) {
        return `${e.entry_number} - `
      } else if (e.exhibitor.exhibitor_number) {
        return `${e.exhibitor.exhibitor_number} - `
      } else {
        return ''
      }
    },
    calculateExhibitor (e) {
      if (e.exhibitor) {
        return `${this.calculateNumberToPrint(e)} ${e.exhibitor.first_name} ${e.exhibitor.last_name}`
      } else {
        return ''
      }
    },
    calculateExhibitorName_export (e) {
      if (e.exhibitor) {
        if (this.adminData.event.event_id === '227721e4-1310-11eb-b863-0e8cd1df2091') {
          let group = this.adminData.entry_groups.filter(eg => {
            return eg.user.user_id === e.exhibitor.user_id
          })[0]
          let city = ''
          let state = ''
          if (group) {
            if (group.user.address.city) {
              city = group.user.address.city
            }
            if (group.user.address.state) {
              state = group.user.address.state
            }
          }
          return `${e.exhibitor.exhibitor_number} - ${e.exhibitor.first_name} ${e.exhibitor.last_name} - (${city}, ${state})`
        } else {
          return `${e.exhibitor.first_name} ${e.exhibitor.last_name}`
        }
      } else {
        return ''
      }
    },
    getClassNumber (c, i) {
      // return c.new_class_number
      return c.true_class_number
    },
    dqEntry (e) {
      e.place = 'DQ'
      this.updateEntryPlacing(e)
    },
    gateScratchEntry (e) {
      e.place = 'SCRATCH'
      this.updateEntryPlacing(e)
    },
    updateShowBook (e) {
      this.sortShowBookPlacing()
      this.resultsSaving = true
      this.$store.dispatch('saveShowBook', {
        event_id: this.adminData.event.event_id,
        show_id: this.show_book.show_id,
        show_book: this.getOriginalOrder(this.show_book.show_book),
        user_id: this.currentUser.user_id,
        testMode: this.testMode
      })
        .then(response => {
          this.resultsSaving = false
          this.notie.alert({
            type: 1,
            text: `Results Saved`
          })
          this.$store.state.apiInstance.get(`/points?event_id=${this.adminData.event.event_id}`)
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error Saving result please refresh the browser and try again`
          })
          this.resultsSaving = false
        })
    },
    updateEntryPlacing (entry) {
      entry.entry_details.place = entry.place
      if (entry.entry_id && !this.testMode) {
        this.$store.dispatch('saveEntryPlacing', {
          entry_id: entry.entry_id,
          entry_details: entry.entry_details
        })
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error Saving placing please refresh the browser and try again`
            })
          })
      }
    },
    updateEntryScore (entry) {
      entry.entry_details.score = entry.score
      if (entry.entry_id) {
        this.$store.dispatch('saveEntryScore', {
          entry_id: entry.entry_id,
          entry_details: entry.entry_details
        })
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error Saving score please refresh the browser and try again`
            })
          })
      }
    },
    updateEntryRibbon (entry) {
      entry.entry_details.ribbon = entry.ribbon
      if (entry.entry_id) {
        this.$store.dispatch('saveEntryRibbon', {
          entry_id: entry.entry_id,
          entry_details: entry.entry_details
        })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error Saving ribbon please refresh the browser and try again`
            })
          })
      }
    },
    getShowBook () {
      this.resultsLoading = true
      this.$store.dispatch('getShowBook', {
        show_id: this.show_book.show_id,
        preview: false,
        regen: false,
        breakable: false,
        results: true,
        start_date: this.adminData.event.start_date,
        use_dynamic: this.adminData.event.event_settings.dynamic_class_lists,
        add_class_numbers: true,
        testMode: this.testMode
      })
        .then(response => {
          if (response.data.data !== null) {
            Vue.set(this.show_book, 'show_book', response.data.show_book)
            this.resultsLoading = false

            this.show_settings = response.data.show_settings

            if (!this.show_settings.starting_class_number) {
              Vue.set(this.show_settings, 'starting_class_number', 1)
            }
            if (!this.show_settings.hasOwnProperty('print_empty_divisions')) {
              Vue.set(this.show_settings, 'print_empty_divisions', true)
            }
            if (!this.show_settings.hasOwnProperty('show_class_break_numbers')) {
              Vue.set(this.show_settings, 'show_class_break_numbers', true)
            }
            this.results_published = response.data.show_settings.publish_results
            this.sortShowBookPlacing()

            this.selectedDivision = this.division_list[0]
          }
          this.resultsLoading = false
          setTimeout(() => {
            if (this.$refs.liveController) {
              this.$refs.liveController.setClasses(this.classList)
            }
          }, 2000)
        })
        .catch(response => {
          this.resultsLoading = false
        })
    },
    sortShowBookPlacing () {
      this.show_book.show_book.forEach(c => {
        if (c.entries) {
          c.entries = c.entries.sort((a, b) => {
            if (a.place === '' || a.place === null || a.place === 'DQ' || a.place === 'SCRATCH' || a.place === 'NP') return 1
            if (b.place === '' || b.place === null || b.place === 'DQ' || b.place === 'SCRATCH' || b.place === 'NP') return -1
            if (a.place === b.place) return 0
            return a.place - b.place
          })
        }
      })
    },
    getOriginalOrder (book) {
      let temp = JSON.parse(JSON.stringify(book))
      temp.forEach(c => {
        if (c.entries) {
          c.entries = c.entries.sort((a, b) => {
            let aOrder = a.saved_order ? a.saved_order : a.order
            let bOrder = b.saved_order ? b.saved_order : b.order
            if (aOrder === bOrder) return 0
            return aOrder - bOrder
          })
        }
      })
      return temp
    },
    setChampionResult (c, option) {
      // Vue.set(this.champion_results, c.classID, c.winner)
      if (!this.testMode) {
        this.$store.dispatch('saveShowChampionResults', {show_id: this.show_book.show_id, champion_results: this.champion_results})
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error Saving placing please refresh the browser and try again`
            })
          })
      }
    },
    getChampionCountFromClassName (className) {
      let lowerName = className.toLowerCase()
      if (lowerName.includes('reserve')) {
        return 2
      } else if (lowerName.includes('3rd')) {
        return 3
      } else if (lowerName.includes('4th')) {
        return 4
      } else if (lowerName.includes('5th')) {
        return 5
      } else if (lowerName.includes('6th')) {
        return 6
      } else if (lowerName.includes('7th')) {
        return 7
      } else if (lowerName.includes('8th')) {
        return 8
      } else if (lowerName.includes('9th')) {
        return 9
      } else if (lowerName.includes('10th')) {
        return 10
      } else {
        return 1
      }
    },
    getChampionList2 (c) {
      let champCnt = this.getChampionCountFromClassName(c.calculated_class_name)
      // Need to actually make this more useful in other use cases
      // And make the settings actually tie to advanced entry fields
      if (c.settings) {
        if (c.settings.advanced) {
          champCnt = 10
        }
      }

      let entries = []
      if (this.show_book) {
        this.show_book.show_book.forEach(c => {
          if (c.entries) {
            c.entries.forEach(e => {
              e.entry_details.exhibitor = this.calculateExhibitorName_export(e)
              e.entry_details.exhibitor_number = this.calculateNumberToPrint(e)
              if (e.place && e.place <= champCnt) {
                entries.push({...e.entry_details, entry_id: e.entry_id, division: c.division, sub_division: c.sub_division, division_group: c.division_group})
              }
            })
          }
        })
      }

      // Filter
      let divFilterEntries = entries.filter(e => {
        return (((e.division ? (e.division === c.division) : true) || c.division === 'Overall' || e.division_group === c.division))
      })

      if (c.settings) {
        if (c.settings.advanced) {
          if (c.settings.champion_type === 'FIELD') {
            return divFilterEntries.filter(e => e[c.settings.filter_field] === true || e[c.settings.field_filter] === 'Yes')
          } else if (c.settings.champion_type === 'EXHIBITOR') {
            return this.exhibitorList
          }
        }
      }
      return divFilterEntries
    },
    getChampionList (c) {
      return this.potentialChampionEntries.filter(e => {
        return ((e.division ? (e.division === c.division) : true) && (e.sub_division === c.sub_division || c.sub_division === 'Overall'))
      })
    },
    showSettingsUpdate (updateField) {
      let payload = {}
      // if (!this.selectedRing) {
      payload = {
        show_id: this.show_book.show_id,
        field: updateField,
        value: this.show_settings[updateField]
      }

      this.$store.dispatch('updateShowSettings', payload)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Show Settings updated for ${this.show_book.name}`
          })
          this.$store.state.apiInstance.get(`/points?event_id=${this.adminData.event.event_id}`)
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating result please refresh the browser and try again`
          })
        })
    },
    resultsPublishedUpdate () {
      let payload = {}
      // if (!this.selectedRing) {
      payload = {
        show_id: this.show_book.show_id,
        field: 'publish_results',
        value: this.results_published
      }

      this.$store.dispatch('updateShowSettings', payload)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Results ${this.results_published ? 'Published' : 'Unpublished'} for ${this.show_book.name}`
          })
          this.$store.state.apiInstance.get(`/points?event_id=${this.adminData.event.event_id}`)
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating result please refresh the browser and try again`
          })
        })
    },
    navClicked (where) {
      this.$refs['top'].scrollIntoView({
        behavior: 'smooth'
      })

      setTimeout(() => {
        let dropdown = this.$refs[`${where}_dropdown`]
        dropdown.activate()
      }, 300)
    },
    formatDate (date) {
      return this.Localized.formatDate(date, this.adminData.event.location_details.country)
    },
    testModeChange () {
      this.testMode = !this.testMode
      this.getShowBook()
      this.$refs.dropdownButton.close()
    },
    async getBulkShowBooks (options) {
      let showBookResults = await this.$store.state.apiInstance.post(`/results/getAllResults`, {shows: options})
      // Trun Bulk Shows into the field format...
      let finalData = []
      showBookResults.data.forEach(showBook => {
        let exportData = []
        let entryDetails = this.adminData.event.shows.find(s => s.show_id === showBook.show_id).entry_details
        let previousDivision = this.classList[0] ? this.classList[0].division : null
        if (showBook.show_book) {
          showBook.show_book.forEach((c, i) => {
            if (previousDivision !== c.division && previousDivision !== null) {
              exportData.push({})
            }
            let row = {}
            if (c.winner) {
              row = {
                // class: c.new_class_name,
                class: c.full_class_name,
                class_number: this.getClassNumber(c, i),
                place: 1,
                exhibitor: c.winner.exhibitor,
                // exhibitor_id: c.winner.exhibitor_id,
                entry_number: c.winner.entry_number,
                weight: c.winner.weight,
                division: c.winner.division
              }
              entryDetails.entry_details.forEach(ed => {
                ed.fields.forEach(f => {
                  if (f.inputType === 'date') {
                    row[f.model] = this.formatDate(c.winner[f.model])
                  } else {
                    row[f.model] = c.winner[f.model]
                  }
                })
              })
              exportData.push(row)
            } else {
              if (c.entries) {
                if (c.entries.length) {
                  c.entries = c.entries.sort((a, b) => {
                    if (a.place === '' || a.place === null || a.place === 'DQ' || a.place === 'SCRATCH' || a.place === 'NP') return 1
                    if (b.place === '' || b.place === null || b.place === 'DQ' || b.place === 'SCRATCH' || b.place === 'NP') return -1
                    if (a.place === b.place) return 0
                    return a.place - b.place
                  })
                  c.entries.forEach(e => {
                    if (e.place !== 'SCRATCH') {
                      row = {
                        // class: c.new_class_name, // c.calculated_class_name ? c.calculated_class_name : c.class_name,
                        class: c.full_class_name,
                        class_number: this.getClassNumber(c, i),
                        place: e.place,
                        exhibitor: this.calculateExhibitorName_export(e),
                        exhibitor_number: e.exhibitor.exhibitor_number,
                        // exhibitor_id: e.exhibitor_id,
                        entry_number: e.entry_number,
                        weight: e.entry_details.weight,
                        division: e.entry_details.division
                      }
                      entryDetails.entry_details.forEach(ed => {
                        ed.fields.forEach(f => {
                          if (f.inputType === 'date') {
                            row[f.model] = this.formatDate(e.entry_details[f.model])
                          } else {
                            row[f.model] = e.entry_details[f.model]
                          }
                        })
                      })
                      let entryGroup = this.adminData.entry_groups.find(eg => e.exhibitor.user_id === eg.user.user_id)
                      if (entryGroup) {
                        row.address = entryGroup.user.address.address_line1
                        row.city = entryGroup.user.address.city
                        row.state = entryGroup.user.address.state
                        row.zip = entryGroup.user.address.zip
                      }
                      exportData.push(row)
                    }
                  })
                }
              }
            }
            previousDivision = c.division
          })
        }
        finalData.push({
          data: exportData,
          headerRow: this.getShowInfoText(showBook.show_id),
          headers: this.getHeaders(showBook.show_id)
        })
      })

      return finalData
    },
    getHeaders (showID) {
      let entryDetails = this.adminData.event.shows.find(s => s.show_id === showID)// .entry_details
      if (entryDetails) {
        entryDetails = entryDetails.entry_details
      }
      let headers = [
        {
          field: 'class',
          header: 'Class'
        },
        {
          field: 'class_number',
          header: 'Class Number'
        },
        {
          field: 'division',
          header: 'division'
        },
        {
          field: 'place',
          header: 'Place'
        },
        {
          field: 'exhibitor',
          header: 'Exhibitor'
        },
        {
          field: 'exhibitor_number',
          header: 'Exhibitor Number'
        },
        {
          field: 'entry_number',
          header: 'Entry Number'
        },
        {
          field: 'weight',
          header: 'Weight'
        },
        {
          field: 'address',
          header: 'address'
        },
        {
          field: 'city',
          header: 'city'
        },
        {
          field: 'state',
          header: 'state'
        },
        {
          field: 'zip',
          header: 'zip'
        }
      ]
      entryDetails.entry_details.forEach(ed => {
        ed.fields.forEach(f => {
          if (f.model !== 'division' && f.model !== 'weight') {
            headers.push({
              field: f.model,
              header: f.label
            })
          }
        })
      })
      return headers
    },
    getShowInfoText (showID) {
      let show = this.adminData.event.shows.find(s => s.show_id === showID)
      return `${this.adminData.event.name} - ${show.name} - ${this.formatDate(show.show_date)}${show.judge ? ` - ${show.judge.first_name} ${show.judge.last_name}` : ''}`
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    userHasAccess () {
      let access = false
      let foundUser = false
      if (this.adminData.admin_id === this.currentUser.user_id || this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2') {
        access = true
      } else {
        this.adminData.event_user_access.forEach(ur => {
          if (ur.user_id === this.currentUser.user_id) {
            foundUser = true
            access = ur.results_access
          }
        })
      }
      // If still no code set check if included in admin_id then assume it is a show series specialist and set to FULL for now.
      if (!foundUser) {
        if (this.adminData.admin_ids.includes(this.currentUser.user_id)) {
          access = true
        } else if (this.currentUser.role === 'ADMIN') {
          access = true
        }
      }
      return access
    },
    showDecode () {
      var obj = {}
      if (this.adminData) {
        this.adminData.event.shows.forEach(s => {
          obj[s.show_id] = s
        })
      }
      return obj
    },
    weightLabel () {
      let label = 'Weight'
      this.showDecode[this.show_book.show_id].entry_details.entry_details[0].fields.forEach(f => {
        if (f.model === 'weight') {
          label = f.label
        }
      })
      return label
    },
    /* classList_ () {
      let printableBook = []
      if (this.show_book) {
        let startingClassNumber = this.show_book.show_settings.starting_class_number ? this.show_book.show_settings.starting_class_number : 1
        let ringClassNumbers = {}
        let ringNumberChampions = {}
        if (this.ring_list.length) {
          this.ring_list.forEach(r => {
            if (r !== 'Overall') {
              let setting = this.show_book.show_settings.ring_settings.find(rs => rs.name === r)
              ringClassNumbers[r] = setting ? (setting.starting_class_number ? setting.starting_class_number : 1) : 1
              ringNumberChampions[r] = setting ? (setting.number_champion_classes ? setting.number_champion_classes : false) : false
            }
          })
        }
        if (this.show_book.show_book) {
          this.show_book.show_book.forEach(c => {
            if (c.entries) {
              c.entries.forEach(e => {
                if (!e.place) {
                  Vue.set(e, 'place', '')
                }
              })
            }
            if (c.entryType !== 'standard' && (!c.entries || c.entries.length === 0)) {
              if (!c.winner) {
                Vue.set(c, 'winner', null)
              }
            }
            // Calculate Rolling Class Numbers...
            if (this.ring_list.length) {
              let setting = this.show_book.show_settings.ring_settings.find(rs => rs.divisions.includes(c.division))
              if (setting) {
                if (this.show_settings.print_empty_divisions) {
                  if (setting.print_champion_classes || c.entryType === 'standard') {
                    if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                      c.new_class_number = ringClassNumbers[setting.name]
                      ringClassNumbers[setting.name] += 1
                    } else {
                      c.new_class_number = null
                    }
                  }
                  printableBook.push(c)
                } else {
                  let entries = 0
                  if (c.entries) {
                    entries = c.entries.length
                  }
                  if (this.emptyDivision.indexOf(c.division) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                    if (c.settings.sub_division) {
                      if (this.emptySubDivisions.indexOf(`${c.division} - ${c.settings.sub_division}`) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                        if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                          c.new_class_number = ringClassNumbers[setting.name]
                          ringClassNumbers[setting.name] += 1
                        } else {
                          c.new_class_number = null
                        }
                        printableBook.push(c)
                      }
                    } else {
                      if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                        c.new_class_number = ringClassNumbers[setting.name]
                        ringClassNumbers[setting.name] += 1
                      } else {
                        c.new_class_number = null
                      }
                      printableBook.push(c)
                    }
                  }
                }
              } else if (c.division === 'Overall') {
                printableBook.push(c)
              }
            } else {
              if (this.show_settings.print_empty_divisions) {
                // if (this.show_settings.print_champion_classes || c.entryType === 'standard') {
                if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                  c.new_class_number = startingClassNumber
                  startingClassNumber += 1
                } else {
                  c.new_class_number = null
                }
                // }
                printableBook.push(c)
              } else {
                // if (c.entryType === 'standard') {
                let entries = 0
                if (c.entries) {
                  entries = c.entries.length
                }
                if (this.emptyDivision.indexOf(c.division) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                  if (c.settings ? c.settings.sub_division : false) {
                    if (this.emptySubDivisions.indexOf(`${c.division} - ${c.settings.sub_division}`) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                      if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                        c.new_class_number = startingClassNumber
                        startingClassNumber += 1
                      } else {
                        c.new_class_number = null
                      }
                      printableBook.push(c)
                    }
                  } else {
                    if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                      c.new_class_number = startingClassNumber
                      startingClassNumber += 1
                    } else {
                      c.new_class_number = null
                    }
                    printableBook.push(c)
                  }
                }
              }
            }
          })
        }
      }
      // Get Division Number
      if (this.show_settings.renumber_divisions) {
        let currentDivision = null
        let currentDivisionClassNumber = 0
        printableBook.forEach(c => {
          if (currentDivision === c.division) {
            currentDivisionClassNumber += 1
          } else if (currentDivision !== c.division) {
            currentDivisionClassNumber = 0
          }

          if (!this.show_settings.number_champion_classes && c.entryType === 'Champion') {
            currentDivisionClassNumber -= 1
          }

          currentDivision = c.division
          Vue.set(c, 'divisionNumber', currentDivisionClassNumber)
        })
      }
      return printableBook
    }, */
    classList () {
      let printableBook = []
      if (this.show_book) {
        printableBook = this.show_book.show_book
      }
      return printableBook
    },
    /* classList__ () {
      let printableBook = []
      if (this.show_book) {
        let startingClassNumber = this.show_book.show_settings.starting_class_number ? this.show_book.show_settings.starting_class_number : 1
        let ringClassNumbers = {}
        let ringNumberChampions = {}
        if (this.ring_list.length) {
          this.ring_list.forEach(r => {
            if (r !== 'Overall') {
              let setting = this.show_book.show_settings.ring_settings.find(rs => rs.name === r)
              ringClassNumbers[r] = setting ? (setting.starting_class_number ? setting.starting_class_number : 1) : 1
              ringNumberChampions[r] = setting ? (setting.number_champion_classes ? setting.number_champion_classes : false) : false
            }
          })
        }
        if (this.show_book.show_book) {
          this.show_book.show_book.forEach(c => {
            // Set empty settings if not set
            if (!c.settings) {
              Vue.set(c, 'settings', {})
            }

            if (c.entries) {
              c.entries.forEach(e => {
                if (!e.place) {
                  Vue.set(e, 'place', '')
                }
              })
            }
            if (c.entryType !== 'standard' && (!c.entries || c.entries.length === 0)) {
              if (!c.winner) {
                Vue.set(c, 'winner', null)
              }
            }
            // Calculate Rolling Class Numbers...
            if (this.ring_list.length) {
              let setting = this.show_book.show_settings.ring_settings.find(rs => rs.divisions.includes(c.division))
              if (setting) {
                if (setting.print_empty_divisions) {
                  if (setting.print_champion_classes || c.entryType === 'standard') {
                    if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                      c.new_class_number = ringClassNumbers[setting.name]
                      ringClassNumbers[setting.name] += 1
                    } else {
                      c.new_class_number = null
                    }
                  }
                  printableBook.push(c)
                } else {
                  let entries = 0
                  if (c.entries) {
                    entries = c.entries.length
                  }
                  if (this.emptyDivision.indexOf(c.division) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                    if (c.settings.sub_division) {
                      if (this.emptySubDivisions.indexOf(`${c.division} - ${c.settings.sub_division}`) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                        if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                          c.new_class_number = ringClassNumbers[setting.name]
                          ringClassNumbers[setting.name] += 1
                        } else {
                          c.new_class_number = null
                        }
                        printableBook.push(c)
                      }
                    } else {
                      if (c.entryType !== 'Champion' || ringNumberChampions[setting.name]) {
                        c.new_class_number = ringClassNumbers[setting.name]
                        ringClassNumbers[setting.name] += 1
                      } else {
                        c.new_class_number = null
                      }
                      printableBook.push(c)
                    }
                  }
                }
              } else if (c.division === 'Overall') {
                printableBook.push(c)
              }
            } else {
              if (this.show_settings.print_empty_divisions) {
                // if (this.show_settings.print_champion_classes || c.entryType === 'standard') {
                if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                  c.new_class_number = startingClassNumber
                  startingClassNumber += 1
                } else {
                  c.new_class_number = null
                }
                // }
                printableBook.push(c)
              } else {
                // if (c.entryType === 'standard') {
                let entries = 0
                if (c.entries) {
                  entries = c.entries.length
                }
                if (this.emptyDivision.indexOf(c.division) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                  if (c.settings ? c.settings.sub_division : false) {
                    if (this.emptySubDivisions.indexOf(`${c.division} - ${c.settings.sub_division}`) === -1 && (entries !== 0 || c.entryType === 'Champion')) {
                      if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                        c.new_class_number = startingClassNumber
                        startingClassNumber += 1
                      } else {
                        c.new_class_number = null
                      }
                      printableBook.push(c)
                    }
                  } else {
                    if (c.entryType !== 'Champion' || this.show_settings.number_champion_classes) {
                      c.new_class_number = startingClassNumber
                      startingClassNumber += 1
                    } else {
                      c.new_class_number = null
                    }
                    printableBook.push(c)
                  }
                }
              }
            }
          })
        }
      }

      let settings = this.show_settings
      if (this.ring_list.length) {
        settings = this.show_book.show_settings.ring_settings.find(rs => rs.divisions.includes(this.selectedDivision.name))
      }
      if (!settings) {
        settings = {}
      }

      // Get Division Number
      if (settings.renumber_divisions) {
        let currentDivision = null
        let currentDivisionClassNumber = 0
        printableBook.forEach(c => {
          if (currentDivision === c.division) {
            currentDivisionClassNumber += 1
          } else if (currentDivision !== c.division) {
            currentDivisionClassNumber = 0
          }

          if (!settings.number_champion_classes && c.entryType === 'Champion') {
            currentDivisionClassNumber -= 1
          }

          currentDivision = c.division
          Vue.set(c, 'divisionNumber', currentDivisionClassNumber)
        })
      }

      let group = []
      let tempPrintableBook = []
      printableBook.forEach((c, i) => {
        if (c.entryType === 'standard' && (settings.numbering_type === 'ALPHA' || settings.numbering_type === 'DIVISION')) {
          if (!group.length) {
            group = [
              c
            ]
          } else {
            if (c.class_name === group[0].class_name) {
              group.push(c)
            } else {
              tempPrintableBook.push(group)
              group = [
                c
              ]
            }
          }
        } else {
          if (group) {
            tempPrintableBook.push(group)
            group = []
          }
          tempPrintableBook.push(c)
        }
      })
      if (group.length) {
        tempPrintableBook.push(group)
      }
      printableBook = tempPrintableBook
      let revNum = 0
      tempPrintableBook = []
      printableBook.forEach(c => {
        if (c.divisionNumber === 0 && this.show_settings.renumber_divisions) {
          revNum = 0
        }
        if (Array.isArray(c)) {
          if (settings.numbering_type === 'ALPHA') {
            c.forEach((sc, j) => {
              sc.new_class_name = this.getClassName(c[0], c[0].new_class_number - 1 - revNum, c.length === 1 ? '' : CLASS_LETTERS[j])
              tempPrintableBook.push(sc)
            })
            revNum += c.length - 1
            // classNum += 1
          } else if (settings.numbering_type === 'DIVISION') {
            c.forEach((sc, j) => {
              sc.new_class_name = this.getClassName(c[0], sc.new_class_number - 1 - revNum, '', c.length === 1 ? 0 : j + 1)
              tempPrintableBook.push(sc)
              // classNum += 1
            })
          }
        } else {
          c.new_class_name = this.getClassName(c, c.new_class_number - 1 - revNum)
          tempPrintableBook.push(c)
          if (settings.number_champion_classes || c.entryType === 'standard') {
            // classNum += 1
          }
          // classNum += 1
        }
      })
      printableBook = tempPrintableBook
      return printableBook
    }, */
    resultsLoaded () {
      if (this.show_book && !this.resultsLoading) {
        return true
      } else {
        return false
      }
    },
    ring_list () {
      let ringList = []
      if (this.resultsLoaded) {
        if (this.show_book.show_settings.ring_settings) {
          this.show_book.show_settings.ring_settings.forEach(r => {
            ringList.push(r.name)
          })
        }
      }
      return ringList
    },
    divisions () {
      let div = new Set()
      if (this.resultsLoaded) {
        this.show_book.show_book.forEach(c => {
          // if (c.entryType.toLowerCase() === 'standard') { // && !c.hide) {
          div.add(c.division)
          // }
        })
      }
      return div
    },
    division_list () {
      let divList = []
      this.divisions.forEach(d => {
        let count = 0
        this.show_book.show_book.forEach(c => {
          if (c.division === d) {
            if (c.entries) {
              count += c.entries.length
            }
          }
        })
        if (count > 0 || (d === 'Overall' && divList.length > 0) || this.show_book.show_book.find(c => c.division_group === d)) {
          let isChampion = Boolean(d === 'Overall' || (this.show_book.show_book.find(c => c.division_group === d) && count === 0))
          divList.push({
            name: d,
            count: count,
            is_champion: isChampion
          })
        }
      })
      return divList
    },
    totalEntries () {
      return this.division_list.reduce((a, c) => a + c.count, 0)
    },
    emptyDivision () {
      let empty = {}
      let emptyDivs = []
      if (this.show_book) {
        this.show_book.show_book.forEach((c, i) => {
          if (c.entryType === 'standard') {
            empty[c.division] ? empty[c.division] += c.entries.length : empty[c.division] = c.entries.length
          }
        })
        Object.keys(empty).forEach(k => {
          if (empty[k] === 0) {
            emptyDivs.push(k)
          }
        })
      }
      return emptyDivs
    },
    emptySubDivisions () {
      let empty = {}
      let emptyDivs = []

      this.show_book.show_book.forEach((c, i) => {
        if (c.entryType === 'standard') {
          empty[`${c.division} - ${c.settings.sub_division}`] ? empty[`${c.division} - ${c.settings.sub_division}`] += c.entries.length : empty[`${c.division} - ${c.settings.sub_division}`] = c.entries.length
        }
      })
      Object.keys(empty).forEach(k => {
        if (empty[k] === 0) {
          emptyDivs.push(k)
        }
      })
      return emptyDivs
    },
    currentUser () {
      return this.$store.state.user
    },
    event_show_type () {
      let calc = {}
      if (this.show_book) {
        calc = this.adminData.event_show_types.find(et => et.event_show_type_id === this.show_book.entry_details_id)
      }
      return calc
    },
    potentialChampionEntries () {
      let entries = []
      if (this.show_book) {
        this.show_book.show_book.forEach(c => {
          if (c.entries) {
            c.entries.forEach(e => {
              e.entry_details.exhibitor = this.calculateExhibitorName_export(e)
              let champCnt = this.event_show_type.class_calc.champions_selected ? this.event_show_type.class_calc.champions_selected : 2
              if (e.place && e.place <= champCnt) {
                if (this.show_book.type !== 'MARKET') {
                  entries.push({...e.entry_details, entry_id: e.entry_id, division: c.division, sub_division: c.sub_division})
                } else {
                  entries.push({...e.entry_details, entry_id: e.entry_id, division: c.division, sub_division: c.sub_division})
                }
              }
            })
          }
        })
      }
      return entries
    },
    detailedExportableResults () {
      let exportData = []
      let entryDetails = this.adminData.event.shows.find(s => s.show_id === this.show_book.show_id).entry_details
      let previousDivision = this.classList[0] ? this.classList[0].division : null
      if (this.classList) {
        this.classList.forEach((c, i) => {
          if (previousDivision !== c.division) {
            exportData.push({})
          }
          let row = {}
          if (c.winner) {
            row = {
              // class: c.new_class_name,
              class: c.full_class_name,
              class_number: this.getClassNumber(c, i),
              place: 1,
              exhibitor: c.winner.exhibitor,
              exhibitor_id: c.winner.exhibitor_id,
              entry_number: c.winner.entry_number,
              weight: c.winner.weight,
              division: c.winner.division
            }
            entryDetails.entry_details.forEach(ed => {
              ed.fields.forEach(f => {
                if (f.inputType === 'date') {
                  row[f.model] = this.formatDate(c.winner[f.model])
                } else {
                  row[f.model] = c.winner[f.model]
                }
              })
            })
            exportData.push(row)
          } else {
            if (c.entries) {
              if (c.entries.length) {
                c.entries = c.entries.sort((a, b) => {
                  if (a.place === '' || a.place === null || a.place === 'DQ' || a.place === 'SCRATCH' || a.place === 'NP') return 1
                  if (b.place === '' || b.place === null || b.place === 'DQ' || b.place === 'SCRATCH' || b.place === 'NP') return -1
                  if (a.place === b.place) return 0
                  return a.place - b.place
                })
                c.entries.forEach(e => {
                  if (e.place !== 'SCRATCH') {
                    row = {
                      // class: c.new_class_name, // c.calculated_class_name ? c.calculated_class_name : c.class_name,
                      class: c.full_class_name,
                      class_number: this.getClassNumber(c, i),
                      place: e.place,
                      exhibitor: this.calculateExhibitorName_export(e),
                      exhibitor_number: e.exhibitor.exhibitor_number,
                      exhibitor_id: e.exhibitor_id,
                      entry_number: e.entry_number,
                      weight: e.entry_details.weight,
                      division: e.entry_details.division
                    }
                    entryDetails.entry_details.forEach(ed => {
                      ed.fields.forEach(f => {
                        if (f.inputType === 'date') {
                          row[f.model] = this.formatDate(e.entry_details[f.model])
                        } else {
                          row[f.model] = e.entry_details[f.model]
                        }
                      })
                    })
                    let entryGroup = this.adminData.entry_groups.find(eg => e.exhibitor.user_id === eg.user.user_id)
                    if (entryGroup) {
                      row.address = entryGroup.user.address.address_line1
                      row.city = entryGroup.user.address.city
                      row.state = entryGroup.user.address.state
                      row.zip = entryGroup.user.address.zip
                    }
                    exportData.push(row)
                  }
                })
                // exportData.push({})
              }
            }
          }

          previousDivision = c.division

          // exportData.push({})
          // }
        })
      }
      return exportData
    },
    detailed_headers () {
      if (this.show_book) {
        let entryDetails = this.adminData.event.shows.find(s => s.show_id === this.show_book.show_id).entry_details
        let headers = [
          {
            field: 'class',
            header: 'Class'
          },
          {
            field: 'class_number',
            header: 'Class Number'
          },
          {
            field: 'division',
            header: 'division'
          },
          {
            field: 'place',
            header: 'Place'
          },
          {
            field: 'exhibitor',
            header: 'Exhibitor'
          },
          {
            field: 'exhibitor_number',
            header: 'Exhibitor Number'
          },
          {
            field: 'entry_number',
            header: 'Entry Number'
          },
          {
            field: 'weight',
            header: 'Weight'
          },
          {
            field: 'address',
            header: 'address'
          },
          {
            field: 'city',
            header: 'city'
          },
          {
            field: 'state',
            header: 'state'
          },
          {
            field: 'zip',
            header: 'zip'
          }
        ]
        entryDetails.entry_details.forEach(ed => {
          ed.fields.forEach(f => {
            if (f.model !== 'division' && f.model !== 'weight') {
              headers.push({
                field: f.model,
                header: f.label
              })
            }
          })
        })
        return headers
      } else {
        return []
      }
    },
    champion_results () {
      let results = {}
      if (this.show_book) {
        this.show_book.show_book.forEach(c => {
          if (c.winner) {
            results[c.classID] = c.winner
          }
        })
      }
      return results
    },
    exhibitorList () {
      let list = []
      if (this.show_book) {
        this.show_book.show_book.forEach(c => {
          if (c.entries) {
            c.entries.forEach(e => {
              let tempExhibitor = {...e.exhibitor}
              tempExhibitor.exhibitor = this.calculateExhibitorName_export(e)
              if (!list.some(el => el.exhibitor_id === tempExhibitor.exhibitor_id)) {
                list.push(tempExhibitor)
              }
            })
          }
        })
      }
      return list
    },
    downloadShowOptions () {
      return this.adminData.event.shows.map(s => {
        return {
          name: `${s.name}`,
          id: s.show_id
        }
      })
    }
  }
}
</script>

<style>

</style>
